import fetch, { toFormData } from './fetch'

export const login = (authType: string, data: any) => fetch.post('/login', toFormData(data), { params: { authType } })

export const authorize = (data: any) => fetch.post('/oauth/authorize', toFormData(data))

export const who = () => fetch.get('/who')
